/*
 * @Description  : 浏览器相关的信息
 * @usage        :
 * @Date         : 2021-10-26 16:32:49
 * @Author       : hadeshe<hadeshe@tencent.com>
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-02-11 10:29:53
 * @FilePath: /vise/packages/app-share/src/composable/use-provide-browser-info.ts
 */

import { useSSRContext, provide } from 'vue';

import { IS_SSR } from '@/utils/env';
import getBrowserObj from '@/utils/no-import-meta/get-browser-obj';

export const PROVIDED_BROWSER_INFO_NAME = 'browserInfo';

export default function useProvideBrowserInfo() {
  // 获取 ua
  let ua = '';
  if (IS_SSR) {
    ({ userAgent: ua = '' } = useSSRContext() || {});
  } else {
    ua = navigator.userAgent || '';
  }
  // 生成工具类并开始解析
  const info = getBrowserObj(ua);
  // provide 信息
  const provideInfo = () => {
    provide(PROVIDED_BROWSER_INFO_NAME, info);
  };
  // 返回相关信息
  return {
    info,
    provideInfo,
  };
};
